'use client'
import React from 'react'

export enum ChoiceListTypes {
    DEFAULT = 'default',
    INLINE = 'inline',
}

export interface ChoiceListProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Vertical or horizontal layout */
    type?: ChoiceListTypes
}

/** UI component for grouping radio buttons */
export const ChoiceList = ({ type = ChoiceListTypes.DEFAULT, children, ...props }: ChoiceListProps) => {
    const getTypeClasses = () => {
        switch (type) {
            case ChoiceListTypes.INLINE:
                return 'inline-flex flex-wrap items-center gap-x-3 gap-y-2'
            default:
                return 'flex flex-col'
        }
    }

    return <div className={`${props.className || ''} ${getTypeClasses()}`}>{children}</div>
}
